import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { ROUTES } from '@/constants/routes'

import apiService from '@/lib/apiUtils'

export function useFetch(url, isThirdPartyAPI, fetchOnMount = false) {
  const navigate = useNavigate()

  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const apiRequest = useCallback(
    async ({
      method,
      reqData = {},
      url: urlOverride,
      onSuccess = f => f,
      onError = f => f
    } = {}) => {
      const targetUrl = urlOverride ?? url
      if (!targetUrl) {
        return undefined
      }
      setLoading(true)
      setError(null)
      setData(null)
      try {
        const response = await apiService[method || 'get']?.(targetUrl, reqData, isThirdPartyAPI)
        onSuccess(response)
        setData(response)
        return response
      } catch (error) {
        const { message, cause } = error || {}
        showSnackbar(message)
        onError(error)
        if (cause?.statusCode === 401 && !isThirdPartyAPI) {
          navigate(ROUTES.LOGOUT)
        }
        setError(cause?.data || 'Something Went Wrong')
      } finally {
        setLoading(false)
      }
    },
    [url, navigate, isThirdPartyAPI]
  )

  useEffect(() => {
    if (fetchOnMount) {
      apiRequest()
    }
  }, [fetchOnMount])

  return { data, loading, error, apiRequest }
}
